import Page from '@/components/pages/news-article/NewsArticlePageController';
import getStaticPaths from '@/components/pages/news-article/NewsArticlePageStaticPaths';
import getStaticProps from '@/components/pages/news-article/NewsArticlePageStaticProps';

export default Page;
export { getStaticProps, getStaticPaths };
